module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"changePlan":"Change plan","subject":"Your new plan is “{plan}”","renewPlan":"Renew subscription"}}')
  delete Component.options._Ctor
}
